import React from "react";
import { Link } from "react-router-dom";

class Page6 extends React.Component {
  state = {
    visible: true,
    question1Answer: null,
    question2Answer: null,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 6) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  saveAnswer1Change = (event) => {
    this.setState({ question1Answer: event.target.value });
    this.props.updatePdf1(event.target.value);
  };

  saveAnswer2Change = (event) => {
    this.setState({ question2Answer: event.target.value });
    this.props.updatePdf2(event.target.value);
  };
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">Reflective Questions</h3>
                </li>
              </ul>
            </nav>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex ">
                        <div className="p-2" id="moduleContentText">
                          Which of the five attributes did Rosie harness to
                          create her own career?
                        </div>
                      </div>
                      <br />
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        <div className="form-group">
                          <textarea
                            className="form-control "
                            id="exampleFormControlTextarea1"
                            placeholder="Enter your answer here..."
                            rows="10"
                            value={this.state.question1Answer}
                            onChange={this.saveAnswer1Change}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex ">
                        <div className="p-2" id="moduleContentText">
                          How can you apply 'planned happenstance' to create
                          your career?
                        </div>
                      </div>
                      <br />
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        <div className="form-group">
                          <textarea
                            className="form-control "
                            id="exampleFormControlTextarea1"
                            placeholder="Enter your answer here..."
                            rows="10"
                            value={this.state.question2Answer}
                            onChange={this.saveAnswer2Change}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item  ">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <i>
                            Below are some ideas to spur you into action, we
                            suggest you commit to three:
                          </i>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item  form-card-1 ">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <strong>
                            - Connect with{" "}
                            <a
                              target="_blank"
                              href="https://www.facebook.com/bathunicareers/"
                            >
                              Bath Careers
                            </a>{" "}
                            on{" "}
                            <a target="_blank" href="https://www.facebook.com/">
                              Facebook
                            </a>{" "}
                            to keep up to date with career related news and
                            opportunities.
                          </strong>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item  form-card-2 ">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <strong>
                            - Get involved with the SU on{" "}
                            <a
                              target="_blank"
                              href="https://www.thesubath.com/"
                            >
                              campus
                            </a>{" "}
                            when you start your studies
                          </strong>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item form-card-1 ">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <strong>
                            - Meet employers on{" "}
                            <a
                              target="_blank"
                              href="https://www.bath.ac.uk/guides/careers-service-events-and-fairs/"
                            >
                              campus
                            </a>
                          </strong>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item  form-card-2 ">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <strong>
                            - Talk to{" "}
                            <a
                              target="_blank"
                              href="https://www.bath.ac.uk/campaigns/bath-connection/"
                            >
                              alumni
                            </a>{" "}
                            and get a sense of their career journey
                          </strong>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item  form-card-1 ">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <strong>
                            - Learn how to articulate your{" "}
                            <Link to="/StrengthsActivity" target="_blank">
                              strengths and interests
                            </Link>
                          </strong>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item  form-card-2 ">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <strong>
                            - Keep a journal and reflect on your learning.
                          </strong>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page6;
